<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">

        <a href="javascript:void(0)" class="btn btn-primary" @click.prevent="showAddClientModal" id="show-add-client-modal">
          <i class="mdi mdi-account-multiple-plus mr-1"></i><span>Lisa klient</span>
        </a>

      </div>
      <h4 class="page-title">Kliendid</h4>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="float-right">
          <a target="_blank" href="/api/clients/export" title="Ekspordi 100 uuemat klient">
            <i class="mdi mdi-download mr-1"></i>Ekspordi Standard Booksi
          </a>
        </div>
        <new-client-list/>
      </div>
    </div>

    <modal ref="addClientModal" title="Lisa klient" size="lg">
      <add-client slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Modal from '@/components/Modal'
  import AddClient from '@/components/client/AddClient'
  import NewClientList from '../components/client/NewClientList'

  export default {
    components: {Modal, AddClient, NewClientList},
    methods: {
      showAddClientModal() {
        this.$refs.addClientModal.show()
      }
    }
  }
</script>
